export default "{{ value | currency:currencyCode:'symbol':'0.2-2' }}\n"